/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
import store from '../../store'
import jwt from 'jsonwebtoken'

export default [

  // This  allows you to have pages apart of the app but no rendered inside the dash
  {
    path: '/login',
    meta: {
      name: 'login',
      title: 'ONE | Login',
      requiresAuth: false
    },
    component: () => import(`@/views/Login.vue`),
    // redirect if already signed in
    beforeEnter: async (to, from, next) => {
      if(to.query.redirect == "control"){

        if (store.getters.authorized) { 

          const token =localStorage.getItem('token')
          let redirectDomain = process.env.VUE_APP_REDIRECT_DOMAIN
          const { exp } = jwt.decode(token);
          if(Date.now() >= exp*1000){
            const refreshToken = localStorage.getItem('refreshToken')
            const { exp } = jwt.decode(refreshToken);
            console.log("REFREHSING TOKEN")
            console.log(Date.now() , exp*1000)
            if(Date.now() >= exp*1000){
              //Log out and re authneticate
              await store.dispatch('logout')
  
            }else {
              await store.dispatch('refreshToken')
              window.location.href = `https://control.${redirectDomain}/login?token=${localStorage.getItem('token')}`

            }
          }else{
            window.location.href = `https://control.${redirectDomain}/login?token=${localStorage.getItem('token')}`
          }

    
        }else{
          //   next({
          //     path: '/login',
          //     query: {
          //       redirect: to.query.redirect,
          //     }
          // })
        }
    
      }
      if(to.query.redirect == "backly"){
        let redirectDomain = process.env.VUE_APP_REDIRECT_DOMAIN
        if (store.getters.authorized) { 

          const token =localStorage.getItem('token')
          const { exp } = jwt.decode(token);
          if(Date.now() >= exp*1000){
            const refreshToken = localStorage.getItem('refreshToken')
            const { exp } = jwt.decode(refreshToken);
            console.log("REFREHSING TOKEN")
            console.log(Date.now() , exp*1000)
            if(Date.now() >= exp*1000){
              //Log out and re authneticate
              await store.dispatch('logout')
  
            }else {
              await store.dispatch('refreshToken')
              window.location.href = `https://backly.${redirectDomain}/login?token=${localStorage.getItem('token')}`

            }
          }else{
            window.location.href = `https://backly.${redirectDomain}/login?token=${localStorage.getItem('token')}`
          }

    
        }else{
          //   next({
          //     path: '/login',
          //     query: {
          //       redirect: to.query.redirect,
          //     }
          // })
        }
    
      }



      if(to.query.redirect == "aifarm"){
        let redirectDomain = process.env.VUE_APP_REDIRECT_DOMAIN
        if (store.getters.authorized) { 

          const token =localStorage.getItem('token')
          const { exp } = jwt.decode(token);
          if(Date.now() >= exp*1000){
            const refreshToken = localStorage.getItem('refreshToken')
            const { exp } = jwt.decode(refreshToken);
            console.log("REFREHSING TOKEN")
            console.log(Date.now() , exp*1000)
            if(Date.now() >= exp*1000){
              //Log out and re authneticate
              await store.dispatch('logout')
  
            }else {
              await store.dispatch('refreshToken')
              window.location.href = `https://aifarm.${redirectDomain}/login?token=${localStorage.getItem('token')}`

            }
          }else{
            window.location.href = `https://aifarm.${redirectDomain}/login?token=${localStorage.getItem('token')}`
          }

    
        }else{
          //   next({
          //     path: '/login',
          //     query: {
          //       redirect: to.query.redirect,
          //     }
          // })
        }
    
      }

      if (store.getters.authorized) {
        next('/')
      } else {
        next()
      }
    }
  },
  {
    path: '/logout',
    meta: {
      name: 'logout',
      requiresAuth: true
    },
    beforeEnter: (to, from, next) => {
        store.dispatch('logout')
        next('/')

    }

  },
  {
    path: '/',
    meta: {
      name: 'Dashboard View',
    },
    component: () => import(`@/views/DashboardView.vue`),
    children: [
      {
        path: '/',
        name: 'Dashboard',
        meta: {
          requiresLogin: true,
          title: 'ONE | Dashboard',
        },
        component: () => import(`@/views/Sites.vue`)
      },
      {
        path: '/sites',
        name: 'Sites',
        meta: {
          requiresLogin: true,
          title: 'ONE | Sites',
        },
        component: () => import(`@/views/Sites.vue`)
      },
      {
        path: '/content',
        name: 'Content',
        meta: {
          requiresAuth: true,
          title: 'ONE | Content',
        },
        component: () => import(`@/views/Content.vue`)
      },
      {
        path: '/posts',
        name: 'Posts',
        meta: {
          requiresAuth: true,
          title: 'ONE | Posts',
        },
        component: () => import(`@/views/Posts.vue`)
      },
      {
        path: '/admin',
        name: 'Admin',
        meta: {
          requiresAdmin: true,
          title: 'ONE | Admin',
        },
        component: () => import(`@/views/Admin.vue`)
      },
      {
        path: '/newsite',
        name: 'New Website',
        meta: {
          requiresAdmin: true,
          title: 'ONE | New Website',
        },
        component: () => import(`@/views/NewWebsite.vue`)
      },
        {
        path: '/ai',
        name: 'ai',
        meta: {
          requiresAuth: true,
          title: 'ONE | AI',
        },
        component: () => import(`@/views/AI.vue`)
      },
    ]
  }
]
